import React from 'react'
import PlanningFilter from '../components/filters/PlanningFilter'
import { useGetPlanningsQuery } from '@/core/services/planning';

interface PlanningFilterContainerProps {
    selectedPlanningId: string | null;
    onPlanningChange: (planningId: string | null) => void;
}

export function PlanningFilterContainer({ selectedPlanningId, onPlanningChange }: PlanningFilterContainerProps) {
    // Fetch plannings data
    const { data: plannings, isLoading } = useGetPlanningsQuery({
        includeArchived: false
    });

    return (
        <PlanningFilter
            selectedPlanningId={selectedPlanningId}
            plannings={plannings}
            isLoading={isLoading}
            onPlanningChange={onPlanningChange}
        />
    );
}

export default PlanningFilterContainer; 